<div class="custom-field-table__wrapper">
  <table class="lum-table lum-table--classic striped">
    <tr class="table__head-row">
      <th>ID</th>
      <th>Label</th>
      <th>Type</th>
      <th class="lum-c-custom-field-table__objects-col">Custom Field Objects</th>
      <th></th>
    </tr>
    <tbody>
      <tr *ngFor="let row of data; trackBy: trackById; let i = index">
        <td>{{ row.id }}</td>
        <td>{{ row.label }}</td>
        <td>{{ row.type }}</td>
        <td class="lum-c-custom-field-table__objects-col">
          <mat-chip-list *ngIf="row.customFieldObjectTypes?.length">
            <mat-chip
              *ngFor="let objectType of row.customFieldObjectTypes; trackBy: trackByValue"
              class="lum-chip border-transparent text-cloud-900 bg-cloud-300 hover:cloud-400 active:cloud-500 focus:cloud-400 lum-chip--small"
            >
              {{ objectType | customFieldObjectLabel }}
            </mat-chip>
          </mat-chip-list>
        </td>
        <td class="flex justify-end position-sticky" style="right: 0">
          <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            (click)="$event.stopPropagation()"
            class="bg-white"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
        <mat-menu #menu="matMenu">
          <button [routerLink]="['/custom-fields/view/', row.id]" mat-menu-item>
            <i class="fas fa-eye"></i>
            View
          </button>
          <button [routerLink]="['/custom-fields/edit/', row.id]" mat-menu-item>
            <i class="fas fa-edit text-info"></i>
            Edit
          </button>
          <button (click)="deleteEvent.emit(row.id)" mat-menu-item>
            <i class="fas fa-trash text-danger"></i>
            Delete
          </button>
        </mat-menu>
      </tr>
    </tbody>
  </table>
</div>
